(() => {
  class ScanwellShippingTableController {
    constructor(ngDialog, Utils) {
      Object.assign(this, {
        ngDialog,
        Utils
      });
    }

    'ngInject';

    showDetails(pharmacyfill) {
      this.openScanwellShippingForm(pharmacyfill, response => {
        if (response && response.success) {
          // Details updated
          // We need to refresh the list
          this.onPageChange();
        } else {// User closed the popup
          // Do nothing
        }
      });
    }

    openScanwellShippingForm(pharmacyfill, callback) {
      return this.ngDialog.open({
        template: 'app/components/scanwell-shipping-form/scanwell-shipping-form.html',
        // To not allow the user closes the modal without explicitely to have some action
        // select the X to close
        // closeByEscape: false,
        // closeByNavigation: false,
        // closeByDocument: false,
        // To make possible doctor still be able to use the screen behind
        // overlay: false,
        controller: 'ScanwellShippingFormController',
        controllerAs: '$ctrl',
        className: 'ngdialog-theme-default scanwell-shipping-form-modal',
        data: {
          labInfo: pharmacyfill
        },

        /**
         * @param {string|object} res - res will be an object if a pharmacy is selected
         */
        preCloseCallback(res) {
          if (typeof res === 'object') {
            return callback(res);
          }

          return callback(false);
        }

      });
    }

  }

  angular.module('pims').component('scanwellShippingTable', {
    templateUrl: 'app/components/scanwell-shipping-table/scanwell-shipping-table.html',
    controller: ScanwellShippingTableController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      pharmacyfills: '<'
    }
  });
})();